import produce from 'immer'
import * as types from 'Redux/Types/DocumentStatsTypes'

const initialState = {
  complianceStats: [],
  documentTypeStats: [],
  fetchingComplianceStats: false,
  fetchingDocumentTypeStats: false,
  fetchingPaymentStats: false,
  fetchingTotalUploadsStats: false,
  fetchingNewInvoicesStats: false,
  fetchingPendingInvoicesStats: false,
  fetchingDiscountInvoicesStats: false,
  fetchingPastDueInvoicesStats: false,
  fetchingExceptionInvoicesStats: false,
  fetchingPOInvoicesStats: false,
  fetchingVendorsInvoicesStats: false,
  fetchingPaymentInvoicesStats: false,
  paymentStats: {},
  totalUploadsStats: [],
  newInvoicesStats: {},
  pendingInvoicesStats: {},
  discountInvoicesStats: {},
  pastDueInvoicesStats: {},
  exceptionInvoicesStats: {},
  poInvoicesStats: {},
  vendorsInvoicesStats: {},
  paymentInvoicesStats: [],
  next: null,
  previous: null,
}

const fetchComplianceStats = (draft) => {
  draft.fetchingComplianceStats = true
}

const fetchComplianceStatsFailed = (draft) => {
  draft.fetchingComplianceStats = false
}

const fetchComplianceStatsSucceeded = (draft, payload) => {
  draft.fetchingComplianceStats = false
  draft.complianceStats = payload
}

const fetchDocumentTypeStats = (draft) => {
  draft.fetchingDocumentTypeStats = true
}

const fetchDocumentTypeStatsFailed = (draft) => {
  draft.fetchingDocumentTypeStats = false
}

const fetchDocumentTypeStatsSucceeded = (draft, payload) => {
  draft.fetchingDocumentTypeStats = false
  draft.documentTypeStats = payload
}

const fetchPaymentStats = (draft) => {
  draft.fetchingPaymentStats = true
}

const fetchPaymentStatsFailed = (draft) => {
  draft.fetchingPaymentStats = false
}

const fetchPaymentStatsSucceeded = (draft, payload) => {
  draft.fetchingPaymentStats = false
  draft.paymentStats = payload
}

const fetchTotalUploadsStats = (draft) => {
  draft.fetchingTotalUploadsStats = true
}

const fetchTotalUploadsStatsFailed = (draft) => {
  draft.fetchingTotalUploadsStats = false
}

const fetchTotalUploadsStatsSucceeded = (draft, payload) => {
  draft.fetchingTotalUploadsStats = false
  draft.totalUploadsStats = payload
}

const fetchNewInvoicesStats = (draft) => {
  draft.fetchingNewInvoicesStats = true
}

const fetchNewInvoicesStatsFailed = (draft) => {
  draft.fetchingNewInvoicesStats = false
}

const fetchNewInvoicesStatsSucceeded = (draft, payload) => {
  draft.fetchingNewInvoicesStats = false
  draft.newInvoicesStats = payload
}

const fetchPendingInvoicesStats = (draft) => {
  draft.fetchingPendingInvoicesStats = true
}

const fetchPendingInvoicesStatsFailed = (draft) => {
  draft.fetchingPendingInvoicesStats = false
}

const fetchPendingInvoicesStatsSucceeded = (draft, payload) => {
  draft.fetchingPendingInvoicesStats = false
  draft.pendingInvoicesStats = payload
}

const fetchDiscountInvoicesStats = (draft) => {
  draft.fetchingDiscountInvoicesStats = true
}

const fetchDiscountInvoicesStatsFailed = (draft) => {
  draft.fetchingDiscountInvoicesStats = false
}

const fetchDiscountInvoicesStatsSucceeded = (draft, payload) => {
  draft.fetchingDiscountInvoicesStats = false
  draft.discountInvoicesStats = payload
}

const fetchPastDueInvoicesStats = (draft) => {
  draft.fetchingPastDueInvoicesStats = true
}

const fetchPastDueInvoicesStatsFailed = (draft) => {
  draft.fetchingPastDueInvoicesStats = false
}

const fetchPastDueInvoicesStatsSucceeded = (draft, payload) => {
  draft.fetchingPastDueInvoicesStats = false
  draft.pastDueInvoicesStats = payload
}

const fetchExceptionInvoicesStats = (draft) => {
  draft.fetchingExceptionInvoicesStats = true
}

const fetchExceptionInvoicesStatsFailed = (draft) => {
  draft.fetchingExceptionInvoicesStats = false
}

const fetchExceptionInvoicesStatsSucceeded = (draft, payload) => {
  draft.fetchingExceptionInvoicesStats = false
  draft.exceptionInvoicesStats = payload
}

const fetchPOInvoicesStats = (draft) => {
  draft.fetchingPOInvoicesStats = true
}

const fetchPOInvoicesStatsFailed = (draft) => {
  draft.fetchingPOInvoicesStats = false
}

const fetchPOInvoicesStatsSucceeded = (draft, payload) => {
  draft.fetchingPOInvoicesStats = false
  draft.poInvoicesStats = payload
}

const fetchVendorsInvoicesStats = (draft) => {
  draft.fetchingVendorsInvoicesStats = true
}

const fetchVendorsInvoicesStatsFailed = (draft) => {
  draft.fetchingVendorsInvoicesStats = false
}

const fetchVendorsInvoicesStatsSucceeded = (draft, payload) => {
  draft.fetchingVendorsInvoicesStats = false
  draft.vendorsInvoicesStats = payload
}

const fetchPaymentInvoicesStats = (draft) => {
  draft.fetchingPaymentInvoicesStats = true
}

const fetchPaymentInvoicesStatsFailed = (draft) => {
  draft.fetchingPaymentInvoicesStats = false
}

const fetchPaymentInvoicesStatsSucceeded = (draft, payload) => {
  draft.fetchingPaymentInvoicesStats = false
  draft.paymentInvoicesStats = payload
  draft.next = null
  draft.previous = null
}

const documentStatsReducer = (state = initialState, action) => {
  return produce(state, (draft) => {
    const { type, payload } = action

    switch (type) {
      case types.FETCH_COMPLIANCE_STATS:
        return fetchComplianceStats(draft)

      case types.FETCH_COMPLIANCE_STATS_FAILED:
        return fetchComplianceStatsFailed(draft)

      case types.FETCH_COMPLIANCE_STATS_SUCCEEDED:
        return fetchComplianceStatsSucceeded(draft, payload)

      case types.FETCH_DOCUMENT_TYPE_STATS:
        return fetchDocumentTypeStats(draft)

      case types.FETCH_DOCUMENT_TYPE_STATS_FAILED:
        return fetchDocumentTypeStatsFailed(draft)

      case types.FETCH_DOCUMENT_TYPE_STATS_SUCCEEDED:
        return fetchDocumentTypeStatsSucceeded(draft, payload)

      case types.FETCH_PAYMENT_STATS:
        return fetchPaymentStats(draft)

      case types.FETCH_PAYMENT_STATS_FAILED:
        return fetchPaymentStatsFailed(draft)

      case types.FETCH_PAYMENT_STATS_SUCCEEDED:
        return fetchPaymentStatsSucceeded(draft, payload)

      case types.FETCH_TOTAL_UPLOADS_STATS:
        return fetchTotalUploadsStats(draft)

      case types.FETCH_TOTAL_UPLOADS_STATS_FAILED:
        return fetchTotalUploadsStatsFailed(draft)

      case types.FETCH_TOTAL_UPLOADS_STATS_SUCCEEDED:
        return fetchTotalUploadsStatsSucceeded(draft, payload)

      case types.FETCH_INVOICES_STATS:
        return fetchNewInvoicesStats(draft)

      case types.FETCH_INVOICES_STATS_FAILED:
        return fetchNewInvoicesStatsFailed(draft)

      case types.FETCH_INVOICES_STATS_SUCCEEDED:
        return fetchNewInvoicesStatsSucceeded(draft, payload)

      case types.FETCH_PENDING_INVOICES_STATS:
        return fetchPendingInvoicesStats(draft)

      case types.FETCH_PENDING_INVOICES_STATS_FAILED:
        return fetchPendingInvoicesStatsFailed(draft)

      case types.FETCH_PENDING_INVOICES_STATS_SUCCEEDED:
        return fetchPendingInvoicesStatsSucceeded(draft, payload)

      case types.FETCH_DISCOUNT_INVOICES_STATS:
        return fetchDiscountInvoicesStats(draft)

      case types.FETCH_DISCOUNT_INVOICES_STATS_FAILED:
        return fetchDiscountInvoicesStatsFailed(draft)

      case types.FETCH_DISCOUNT_INVOICES_STATS_SUCCEEDED:
        return fetchDiscountInvoicesStatsSucceeded(draft, payload)

      case types.FETCH_PAST_DUE_INVOICES_STATS:
        return fetchPastDueInvoicesStats(draft)

      case types.FETCH_PAST_DUE_INVOICES_STATS_FAILED:
        return fetchPastDueInvoicesStatsFailed(draft)

      case types.FETCH_PAST_DUE_INVOICES_STATS_SUCCEEDED:
        return fetchPastDueInvoicesStatsSucceeded(draft, payload)

      case types.FETCH_EXCEPTION_INVOICES_STATS:
        return fetchExceptionInvoicesStats(draft)

      case types.FETCH_EXCEPTION_INVOICES_STATS_FAILED:
        return fetchExceptionInvoicesStatsFailed(draft)

      case types.FETCH_EXCEPTION_INVOICES_STATS_SUCCEEDED:
        return fetchExceptionInvoicesStatsSucceeded(draft, payload)

      case types.FETCH_PO_INVOICES_STATS:
        return fetchPOInvoicesStats(draft)

      case types.FETCH_PO_INVOICES_STATS_FAILED:
        return fetchPOInvoicesStatsFailed(draft)

      case types.FETCH_PO_INVOICES_STATS_SUCCEEDED:
        return fetchPOInvoicesStatsSucceeded(draft, payload)

      case types.FETCH_VENDORS_INVOICES_STATS:
        return fetchVendorsInvoicesStats(draft)

      case types.FETCH_VENDORS_INVOICES_STATS_FAILED:
        return fetchVendorsInvoicesStatsFailed(draft)

      case types.FETCH_VENDORS_INVOICES_STATS_SUCCEEDED:
        return fetchVendorsInvoicesStatsSucceeded(draft, payload)

      case types.FETCH_PAYMENTS_INVOICES_STATS:
        return fetchPaymentInvoicesStats(draft)

      case types.FETCH_PAYMENTS_INVOICES_STATS_FAILED:
        return fetchPaymentInvoicesStatsFailed(draft)

      case types.FETCH_PAYMENTS_INVOICES_STATS_SUCCEEDED:
        return fetchPaymentInvoicesStatsSucceeded(draft, payload)
      // no default
    }
  })
}

export default documentStatsReducer
